var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaelic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9DBB5",
    d: "M3.08323171,44.8159667 C0.434833525,42.5702745 -2.04216872,36.1214534 2.59354283,34.8868093 C2.78621752,34.8674177 7.79312785,34.557342 15.8788929,26.2754961 C17.0852793,27.5450183 18.6398104,28.1667694 20.1912208,28.6018047 C15.4842528,39.8387552 10.8622706,45.5840584 6.32527411,45.8378616 C5.12327562,45.842985 3.90127968,45.5701304 3.08323171,44.8159667 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA72",
    d: "M23.6393679,22.1877126 L23.2927477,22.7548346 C22.6133882,23.8606505 21.931841,24.9934044 21.2494032,26.1488156 C19.6940371,26.1366851 18.0222294,25.417519 16.841047,24.3120723 L18.4062117,22.3503141 L20.1457401,20.1394942 L21.3295906,18.6222509 C22.08394,19.7497316 22.8537332,20.939319 23.6393679,22.1877126 Z M28.5545097,14.7085188 L26.4604657,12.0184592 L27.9325442,10.1530956 C30.002134,7.5556385 31.8466584,5.35948101 33.4862091,3.70505457 L33.9513382,3.24493247 C34.4025487,4.17389771 35.0243416,4.96446879 35.9067725,5.78149118 C33.5909235,8.01431818 31.1148206,11.07366 28.5545097,14.7085188 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DBB5",
    d: "M41.4765325 2.54232069C41.8399467 4.09842534 40.8243375 4.75373447 38.2057321 4.72266337 36.8738427 3.64885648 36.1786301 2.80216116 35.7546014 1.57245893L35.6704891 1.67217298C37.6104382-.749016513 40.4124005-.610023394 41.4765325 2.54232069ZM34.2541098 26.4112894C42.2617478 34.5607406 47.2148411 34.8675242 47.4064572 34.8868093 52.0421687 36.1214534 49.5651665 42.5702745 46.9167683 44.8159667 46.0987203 45.5701304 44.8767244 45.842985 43.6747259 45.8377889 39.1377294 45.5840584 34.363163 39.6192558 29.656195 28.3823053 31.2383742 28.1980311 32.8148971 27.5306927 34.1052094 26.530733L34.2541098 26.4112894Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.2042705,44.8159667 C34.5558723,42.5702745 32.0788701,36.1214534 36.7145816,34.8868093 C36.9072563,34.8674177 41.9141666,34.557342 50,26.2754961 C47.4139664,33.2638898 31.9749871,38.0046685 40.4463129,45.8377142 C39.2443144,45.842985 38.0223185,45.5701304 37.2042705,44.8159667 Z",
    opacity: 0.296,
    transform: "matrix(-1 0 0 1 84.121 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4BA72",
    d: "M31.2035187,3.24493247 C31.6547292,4.17389771 32.2765221,4.96446879 33.158953,5.78149118 C28.6880506,10.092114 23.5414497,17.4524568 18.4231657,26.117962 C16.8677996,26.1059098 15.2744099,25.417519 14.0932275,24.3120723 L15.6583922,22.3503141 L17.3979206,20.1394942 C22.887924,13.1242299 27.2714231,7.20347714 30.7383896,3.70505457 L31.2035187,3.24493247 Z",
    transform: "matrix(-1 0 0 1 47.252 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9DBB5",
    d: "M8.5234675,2.54232069 C8.16005334,4.09842534 9.17566248,4.75373447 11.7942679,4.72266337 C13.1261573,3.64885648 13.8213699,2.80216116 14.2453986,1.57245893 L14.3295109,1.67217298 C12.3895618,-0.749016513 9.58759954,-0.610023394 8.5234675,2.54232069 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.95,
    cy: 37.875,
    fill: "#FFF",
    rx: 5.338,
    ry: 5.331
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaelic);
export default __webpack_public_path__ + "static/media/gaelic.4b5c118644b41a7337b9ee5efeb44c16.svg";
export { ForwardRef as ReactComponent };